<template>
  <div class="browse">
    <Navbar />
    <div class="mt-5 pt-5 kova-width">
      <div
        class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4 mt-4"
      >
        <div class="text-left mt-3 ml-5 mb-4">
          <a-icon class="mr-1" type="arrow-left" />
          <span class="go-back" @click="goBack">Go Back</span>
        </div>
      </div>
      <div class="browse-list mx-auto mt-2">
        <a-tabs defaultActiveKey="1" @change="callback">
          <!--  <a-tab-pane tab="Job Type" key="1">
            <div class="text-left px-3 px-md-5">
              <div class>
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    v-model="data.filters.seniority_level"
                    :value="1"
                  />
                  <span class="checkbox-custom rectangular"></span>
                  <span class="pl-4 ml-2 ctrl-size-2">Junior ($10-$20/hr)</span>
                </label>
              </div>
              <div class="pt-2">
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    v-model="data.filters.seniority_level"
                    :value="2"
                  />
                  <span class="checkbox-custom rectangular"></span>
                  <span class="pl-4 ml-2 ctrl-size-2"
                    >Intermediate ($15-$40/hr)</span
                  >
                </label>
              </div>
              <div class="pt-2">
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    v-model="data.filters.seniority_level"
                    :value="3"
                  />
                  <span class="checkbox-custom rectangular"></span>
                  <span class="pl-4 ml-2 ctrl-size-2">Senior ($25-$60/hr)</span>
                </label>
              </div>
            </div>
          </a-tab-pane> -->
          <a-tab-pane tab="Expertise Level" key="1">
            <div class="text-left px-3 px-md-5">
              <div class>
                <!-- <label class="checkbox-label">
                                <input type="checkbox" />
                                <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 ctrl-size-2">Hourly</span>
                </label>-->
                <label for="opt1" class="radio text-left">
                  <input
                    type="radio"
                    name="rdo"
                    id="opt1"
                    class="hidden"
                    :value="1"
                    v-model="data.filters.seniority_level"
                  />
                  <span class="label"></span>Junior
                </label>
              </div>
              <div class="pt-2">
                <!-- <label class="checkbox-label">
                                <input type="checkbox" />
                                <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 ctrl-size-2">Fixed</span>
                </label>-->
                <label for="opt2" class="radio text-left">
                  <input
                    type="radio"
                    name="rdo"
                    id="opt2"
                    class="hidden"
                    :value="2"
                    v-model="data.filters.seniority_level"
                  />
                  <span class="label"></span>Intermediate
                </label>
              </div>
              <div class="pt-2">
                <!-- <label class="checkbox-label">
                                <input type="checkbox" />
                                <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 ctrl-size-2">Fixed</span>
                </label>-->
                <label for="opt3" class="radio text-left">
                  <input
                    type="radio"
                    name="rdo"
                    id="opt3"
                    class="hidden"
                    :value="3"
                    v-model="data.filters.seniority_level"
                  />
                  <span class="label"></span>Senior
                </label>
                <br />
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="Work Experience" key="2">
            <div class="text-left px-3 px-md-5">
              <div class>
                <!-- <label class="checkbox-label">
                                <input type="checkbox" />
                                <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 ctrl-size-2">Hourly</span>
                </label>-->
                <label for="we1" class="radio text-left">
                  <input
                    type="radio"
                    name="workexperience"
                    id="we1"
                    class="hidden"
                    :value="1"
                    v-model="data.filters.work_experience"
                  />
                  <span class="label"></span>1
                </label>
              </div>
              <div class="pt-2">
                <!-- <label class="checkbox-label">
                                <input type="checkbox" />
                                <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 ctrl-size-2">Fixed</span>
                </label>-->
                <label for="we2" class="radio text-left">
                  <input
                    type="radio"
                    name="workexperience"
                    id="we2"
                    class="hidden"
                    :value="2"
                    v-model="data.filters.work_experience"
                  />
                  <span class="label"></span>2
                </label>
                <br />
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="Work Rate" key="3">
            <div class="text-left px-3 px-md-5">
              <div class>
                <!-- <label class="checkbox-label">
                                <input type="checkbox" />
                                <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 ctrl-size-2">Hourly</span>
                </label>-->
                <label for="wr1" class="radio text-left">
                  <input
                    type="radio"
                    name="workrate"
                    id="wr1"
                    class="hidden"
                    :value="5"
                    v-model="data.filters.work_rate"
                  />
                  <span class="label"></span>5
                </label>
              </div>
              <div class="pt-2">
                <!-- <label class="checkbox-label">
                                <input type="checkbox" />
                                <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 ctrl-size-2">Fixed</span>
                </label>-->
                <label for="wr2" class="radio text-left">
                  <input
                    type="radio"
                    name="workrate"
                    id="wr2"
                    class="hidden"
                    :value="10"
                    v-model="data.filters.work_rate"
                  />
                  <span class="label"></span>10
                </label>
                <br />
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="Skill" key="4">
            <a-select
              mode="multiple"
              class="w-100"
              @change="handleChange"
              size="large"
              v-model="data.filters.skills"
              placeholder="Enter/Choose skills"
            >
              <a-select-option
                v-for="stack in stacks"
                :key="stack"
                :value="stack"
                >{{ stack }}</a-select-option
              >
            </a-select>
          </a-tab-pane>
          <!-- <a-tab-pane tab="Price Range" key="4">
            <div class="text-left px-3 px-md-5">
              <a-slider
                range
                :step="10"
                :min="0"
                :max="500"
                :defaultValue="[20, 50]"
                @change="onChange"
                @afterChange="onAfterChange"
              />
              <h5 class="mt-3 ml-4 latest">
                ${{ range[0] }} - ${{ range[1] }}
              </h5>
            </div>
          </a-tab-pane> -->
          <a-tab-pane tab="Country" key="5">
            <a-select
              class="w-100"
              size="large"
              placeholder="Please select your Country"
              v-model="data.filters.country"
            >
              <a-select-option
                v-for="(item, index) in countries"
                :key="index"
                :value="item.name"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-tab-pane>
          <a-tab-pane tab="Reset Filter" key="6"></a-tab-pane>
        </a-tabs>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-8 px-md-5">
            <div class="row browse-list mt-4 mx-auto">
              <div class="col-8 col-md-9 mx-0 px-0">
                <a-input
                  class="mt-4 w-100"
                  size="large"
                  placeholder="Search"
                  v-model="data.filters.title"
                  ref="searchInput"
                  autofocus
                >
                  <a-icon slot="prefix" type="search" />
                  <a-tooltip slot="suffix" title="Extra information">
                    <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
                  </a-tooltip>
                </a-input>
              </div>
              <div class="col-4 col-md-3 text-right">
                <span class="sort-by ml-3">
                  <!-- sort by <span class="latest"> latest </span> -->
                  <span class="latest pointer" @click="doSearch">search</span>
                </span>
              </div>
            </div>
            <!-- <div class="bg-light p-4 mt-3 border add-rounded text-center">
            <div class="d-flex flex-wrap justify-content-center dev-section scrollbar">-->
            <div class="mt-4 mb-5">
              <div class="p-4 bg-light border shadow-sm add-rounded">
                <!-- <div :key="work" v-for="work in workHistory">
                                        <div class="row">
                                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                            </div>
                                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                                <h5 class="font-weight-bolder"><router-link to="/dev-profile"><span class="kova-text">{{work.title}}</span></router-link>
                                                    <img class="ml-1 ml-md-2 mb-1" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                                                    <span class="ml-3"><img class="mr-1 rating" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1 kova-green">9.5</span><span class="ml-2 ctrl-size-2 kova-light">56 reviews</span></span>
                                                </h5>
                                                <p><span class="font-italic">Web Developer</span> <span class="ml-3 text-uppercase intermediate ctrl-size-2">intermediate</span> 
                                                    <span class="font-weight-bolder ctrl-size-2 ml-3"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark mr-1"></font-awesome-icon>Lagos, Nigeria</span>
                                                </p>

                                                <p class="text-size2">{{work.comment}}... <router-link to="/dev-profile"><span class="ant-color pointer">see more </span></router-link></p>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span class="kova-bg-green text-white px-3 py-2 mr-3 mb-3 rounded ctrl-size-3 pointer"  v-for="skill in proSkills" :key="skill">
                                                        {{skill}}</span>
                                                    <span class="px-3 py-2 mr-3 mb-3 rounded ctrl-size-3 pointer" style="background-color: #EFEFEF">
                                                    <b>+ more</b></span>
                                                </div>
                                            </div>
                                        
                                        <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text">
                                            <h6 class="font-weight-bolder kova-light ctrl-size-4">Project completed: 11</h6>
                                            <h6 class="font-weight-bolder kova-light ctrl-size-4">Team Work: 4</h6>
                                            <div class="pt-0 mt-1 mt-md-5 pt-md-5">
                                                <font-awesome-icon :icon="['far', 'bookmark']" class="kova-light" style="font-size: 24px"></font-awesome-icon>
                                            </div>
                                            
                                        </div>
                                        </div>
                                        <hr>
                </div>-->
                <div v-if="loading" class="my-5">
                  <hollow-dots-spinner
                    :animation-duration="1000"
                    :dot-size="15"
                    :dots-num="3"
                    color="#20409a"
                    class="mx-auto"
                  />
                  <br />
                  <p>{{ !filtered ? "Filtering..." : "Getting Talents..." }}</p>
                </div>
                <div v-else>
                  <div v-if="talents.length > 0" class>
                    <div :key="talent" v-for="talent in talents">
                      <div class="row">
                        <div class="class col-3 col-sm-3 col-md-2 pl-1">
                          <img
                            src="../assets/kovatek/Mask Group 46.svg"
                            alt
                            class="rounded-circle img-height"
                          />
                        </div>
                        <div class="col-9 col-sm-9 col-md-7 text-left">
                          <h5 class="font-weight-bolder">
                            <router-link to="/dev-profile">
                              <span class="kova-text">{{ talent.Setting.Firstname }} {{ talent.Setting.Surname }}</span>
                            </router-link>
                            <img
                              class="ml-1 ml-md-2 mb-1"
                              style="height:22px;"
                              src="../assets/kovatek/correct.svg"
                              alt
                            />
                            <span class="ml-3">
                              <img
                                class="mr-1 rating"
                                src="../assets/kovatek/best.svg"
                                alt
                              />
                              <span
                                class="font-weight-bolder ctrl-size-1 kova-green"
                                >{{ talent.SkillScore }}</span
                              >
                              <span class="ml-2 ctrl-size-2 kova-light"
                                >{{ talent.Reviews }} reviews</span
                              >
                            </span>
                          </h5>
                          <p>
                            <span class="font-italic">{{ talent.Speciality }}</span>
                            <span
                              class="ml-3 text-uppercase intermediate ctrl-size-2"
                              >{{ computeLevel(talent.SeniorityLevel) }}</span
                            >
                            <span class="font-weight-bolder ctrl-size-2 ml-3">
                              <font-awesome-icon
                                style="font-size: 14px;"
                                icon="map-marker-alt"
                                class="text-dark mr-1"
                              ></font-awesome-icon>
                              {{ talent.City }}, {{ talent.Country }}
                            </span>
                          </p>

                          <p class="text-size2" v-html="talent.AboutMe">
                            
                          </p>
                          <router-link :to="`/dev-profile?id=${talent.UserID}`">
                              <span class="ant-color pointer">see more</span>
                            </router-link>
                          <div class="text-left d-flex flex-wrap">
                            <span
                              class="kova-bg-green text-white px-3 py-2 mr-3 mb-3 rounded ctrl-size-3 pointer"
                              v-for="skill in mergeSkills(talent.CoreTechstack, talent.OtherCoreTechstacks)"
                              :key="skill"
                              >{{ skill }}</span
                            >
                            <!-- <span class="px-3 py-2 mr-3 mb-3 rounded ctrl-size-3 pointer" style="background-color: #EFEFEF">
                            <b>+ more</b></span>-->
                          </div>
                        </div>

                        <div
                          class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text"
                        >
                          <h6 class="font-weight-bolder kova-light ctrl-size-4">
                            Project completed: {{ talent.ProjectsCompleted }}
                          </h6>
                          <h6 class="font-weight-bolder kova-light ctrl-size-4">
                            Team Work: {{ talent.ProjectsLedCount }}
                          </h6>
                          <div class="pt-0 mt-1 mt-md-5 pt-md-5" @click="showSaveTalentModal(talent.UserID)">
                            <font-awesome-icon
                              :icon="['far', 'bookmark']"
                              class="kova-light"
                              style="font-size: 24px"
                            ></font-awesome-icon>
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                  <div v-else class>
                    <h4 class="py-4">Oops! No result found for search</h4>
                  </div>
                </div>

                <div class="mt-4">
                  <a-pagination
                    showQuickJumper
                    :defaultCurrent="2"
                    :total="500"
                    @change="peginationChange"
                  />
                </div>
              </div>
            </div>

            <a-modal
              v-model="saveTalentVisible"
              title="Save Talent"
              @ok="handleOk"
            >
              <p>Save this Talent</p>
            </a-modal>
            <!-- </div>
                        
            </div>-->
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3 pt-lg-4 mt-lg-5"
          >
            <div class="mt-1"></div>
            <div class style="position:sticky;top:0">
              <Notifications />
              <div class="mt-4 pt-1 pb-3">
                <Messages />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
// import DevList from '@/components/DevList.vue'
import Notifications from "@/components/Notifications.vue";
import Messages from "@/components/Messages.vue";
import { HollowDotsSpinner } from "epic-spinners";
import { computeExperienceLevel } from "@/helpers/compute.js";
import countries from "@/plugins/countries.json";

export default {
  name: "Browse",
  components: {
    Navbar,
    Footer,
    Messages,
    Notifications,
    HollowDotsSpinner
  },
  data() {
    return {
      talentToSave: null,
      savedTalent: null,
      saveTalentVisible: false,
      loading: true,
      saveloading: false,
      countries,
      stacks: [
        "React",
        "Angular",
        "Vue",
        "Kotlin",
        "Python",
        "Go",
        "JavaScript",
        "PHP",
        "Nodejs",
        "Django",
        "Flask",
        "Laravel",
        "Java",
        "C#",
        "C++",
        ".NET",
        "Ruby",
        "Scala",
        "Perl",
        "Symfony",
        "Spring",
        "JSF",
        "Others"
      ],
      workHistory: [
        {
          title: "Adebayo Mary",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48
        },
        {
          title: "Adebayo Mary",
          star: 5,
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19
        },
        {
          title: "Adebayo Mary",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48
        },
        {
          title: "Adebayo Mary",
          star: 5,
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19
        },
        {
          title: "Adebayo Mary",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48
        },
        {
          title: "Adebayo Mary",
          star: 5,
          comment:
            "Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19
        }
      ],
      proSkills: ["Database", "Modeling", "Vue.js"],
      range: [],
      talents: [],
      error: "",
      data: {
        offset: 0,
        limit: 10,
        filters: {
          skills: [],
          country: null,
          work_rate: null,
          seniority_level: null,
          title: null,
          work_experience: null
        }
      }
    };
  },
  methods: {
    mergeSkills(CoreTechstack, OtherCoreTechstacks) {
    const array = CoreTechstack.split(',');
    if (OtherCoreTechstacks !== null) {
      for (let i = 0; i < OtherCoreTechstacks.length; i++) {
        array.push(OtherCoreTechstacks[i]);
    }
    }
    return array;
    },
    styleScroll: function() {
      let isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
      let isSafari =
        /Safari/.test(navigator.userAgent) &&
        /Apple Computer/.test(navigator.vendor);
      let scrollbarDiv = document.querySelector(".scrollbar");
      if (!isChrome && !isSafari) {
        scrollbarDiv.innerHTML = "You need Webkit browser to run this code";
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    showSaveTalentModal(talentId){
            this.talentToSave = talentId;
            this.saveTalentVisible = true;
        },
    handleOk() {
      this.saveloading = true;
      const param = {
      talentId: this.talentToSave,
    };
    this.$store
      .dispatch("profiles/saveTalent", param)
      .then(resp => {
        this.savedTalent = resp.data;
        this.saveTalentVisible = false;
        this.saveloading = false;
        this.$toast.fire({
            icon: 'success',
            title: 'Talent saved!',
          });
      })
      .catch(err => {
        this.error = err.message;
        this.$toast.fire({
            icon: 'success',
            title: err.message,
          });
        this.saveloading = false;
        this.saveTalentVisible = false;
      });
        },
    onClickSave(id) {
      const param = {
      talentId: id,
    };
    this.$store
      .dispatch("profiles/saveTalent", param)
      .then(resp => {
        this.savedTalents = resp.data.SavedTalents;
        this.EngagedTalents = resp.data.EngagedTalents;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.message;
        this.loading = false;
      });
    },
    onChange(value) {
      // console.log('change: ', value);
      this.range = value;
    },
    onAfterChange(value) {
      // console.log('afterChange: ', value);
      this.range = value;
    },
    handleChange() {},
    peginationChange() {},
    computeLevel(level) {
      return computeExperienceLevel(level);
    },
    doSearch() {
      this.loading = true;
      const {
        skills,
          country,
          work_rate,
          seniority_level,
          title,
          work_experience
      } = this.data.filters;
      const param = {
        Title: title,
        seniority_level: seniority_level,
        work_rate: work_rate,
        work_experience: work_experience,
        country: country,
        skills: skills,
      };

      this.$store
        .dispatch("profiles/browseTalent", param)
        .then(resp => {
          this.talents = resp.data;
          this.loading = false;
        })
        .catch(err => {
          this.error = err.message;
          this.loading = false;
        });
    },
    callback(key) {
      if (key === "6") {
        const filters = {
           skills: [],
          country: null,
          city: null,
          work_rate: null,
          seniority_level: null,
          title: null,
          work_experience: null
        };
        this.data.filters = { ...filters };
      }
    }
  },
  mounted() {
    // this.$http({
    //     method: 'GET',
    //     url:'https://ajayakv-rest-countries-v1.p.rapidapi.com/rest/v1/all',
    //     headers: {
    //         "x-rapidapi-host": "ajayakv-rest-countries-v1.p.rapidapi.com","x-rapidapi-key": "6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d"
    //     }
    // }).then((response) => {
    //     this.countries = response.data
    //     // console.log(response.data)
    // });
    // this.styleScroll();

    const {
      seniority_level,
      work_experience
    } = this.data.filters;
    const param = {
      Title: "",
      seniority_level: seniority_level,
      work_rate: 2,
      work_experience: work_experience
    };
    this.$store
      .dispatch("profiles/browseTalent", param)
      .then(resp => {
        this.talents = resp.data;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.message;
        this.loading = false;
      });
  }
};
</script>
<style scoped>
.kova-width {
  max-width: 1350px;
  margin: auto;
}
.browse-list {
  width: 80%;
}
.sort-by {
  position: relative;
  top: 33px;
}
.icon-size {
  font-size: 25px;
}
.icon-size1 {
  font-size: 20px;
}
.img-height {
  width: 80px;
  height: 80px;
}
.icon-env {
  font-size: 20px;
}
.ctrl-size {
  font-size: 10px;
}
.ctrl-size-1 {
  font-size: 20px;
}
.ctrl-size-2 {
  font-size: 11px;
}
.ctrl-size-3 {
  font-size: 12px;
}
.ctrl-size-4 {
  font-size: 14px;
}
.latest {
  color: #2db7f5;
}
.rating {
  width: 16px;
}
.dev-section {
  height: 700px;
  overflow-y: scroll;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .img-height {
    width: 60px;
    height: 60px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
  .float-text {
    display: flex;
    justify-content: space-between;
    padding-right: 50px;
  }
  .float-text h6 {
    float: left;
  }
  .browse-list {
    width: 100%;
  }
}

@media screen and (max-width: 550px) {
  .ctrl-search {
    width: 55%;
  }
  .img-height {
    width: 65px;
    height: 65px;
  }
}
</style>
